export default __webpack_public_path__ + "static/media/repoeye.260b867e.png";